<template>
    <main class="page-layout axxess-planner">
        <header class="page-header"></header>
        <div class="page-content px-0" id="Central__Clinician">
            <div class="row-span-3">
                <TaskList />
            </div>
            <PersonalMessageList :is-new-scroll="true" />
            <PastDue />
            <TaskAlerts />
            <div v-if="showBanner" class="banner-container">
                <a :href="banner.link" target="_blank" rel="noopener noreferrer" @click="addLog(banner)">
                    <img :src="banner.src" class="axxess-banner" />
                </a>
                <button class="banner-close" @click="closeBanner(banner)">X</button>
            </div>
        </div>
    </main>
</template>

<script lang="ts" src="./CentralClinician.ts"></script>
<style src="./CentralClinician.scss"></style>
